<template>
  <!--成品配方-->
  <a-modal :title="record.name" visible @cancel="cancel">
    <a-skeleton active v-show="show" />
    <div v-if="!isPC">
      <a-row
        type="flex"
        align="bottom"
        :gutter="20"
        class="m-b-20"
        v-for="(f, index) in formula"
        :key="index"
      >
        <a-col :span="8">
          <div class="m-b-12" v-if="index === 0">选择半成品/原材料</div>
          <!--  -->
          <a-select show-search v-model="f.select.name" style="width: 100%" v-if="f.selectParts">
            <a-select-option
              v-for="p in f.selectParts"
              :key="p.id"
              :value="p.name"
              @click="selectParts(p, index)"
            >{{p.name}}</a-select-option>
          </a-select>
          <!--  -->
          <a-select
            show-search
            v-model="f.select.name"
            style="width: 100%"
            v-if="f.selectMaterials"
          >
            <a-select-option
              v-for="m in f.selectMaterials"
              :key="m.id"
              :value="m.name"
              @click="selectMaterial(m, index)"
            >{{m.name}}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8">
          <div class="m-b-12" v-if="index === 0">重量(KG)</div>
          <a-input-number
            :min="0"
            v-model="f.weight"
            style="width: 100%"
            @blur="focus(f.weight, index)"
          ></a-input-number>
        </a-col>
        <a-col :span="4">
          <div v-if="index === 0">一吨占比</div>
          <div>{{f.tonWeight ? f.tonWeight + 'KG' : '- -'}}</div>
          <div>{{f.ratio ? f.ratio + '%' : '- -'}}</div>
        </a-col>
        <a-col :span="4" class="text-center p-b-4">
          <tk-icon @click.native="deleteMaterial(index)">delete</tk-icon>
        </a-col>
      </a-row>
    </div>
    <div v-else>
      <a-row
        style="border-bottom:1px solid #e8e8e8;padding-bottom:10px"
        type="flex"
        align="bottom"
        :gutter="20"
        class="m-b-20"
        v-for="(f, index) in formula"
        :key="index"
      >
        <a-col :span="24">
          <div class="flex">
            <div>选择</div>
            <a-select show-search v-model="f.select.name" v-if="f.selectParts">
              <a-select-option
                v-for="p in f.selectParts"
                :key="p.id"
                :value="p.name"
                @click="selectParts(p, index)"
              >{{p.name}}</a-select-option>
            </a-select>
            <a-select show-search v-model="f.select.name" v-if="f.selectMaterials">
              <a-select-option
                v-for="m in f.selectMaterials"
                :key="m.id"
                :value="m.name"
                @click="selectMaterial(m, index)"
              >{{m.name}}</a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :span="24">
          <div class="flex">
            <span>重量(KG)</span>
            <a-input-number :min="0" v-model="f.weight" @blur="focus(f.weight, index)"></a-input-number>
          </div>
        </a-col>
        <a-col :span="24">
          <div style="display:flex;justify-content: space-between;">
            <div>一吨占比</div>
            <div>{{f.tonWeight ? f.tonWeight + 'KG' : '- -'}}</div>
            <div>{{f.ratio ? f.ratio + '%' : '- -'}}</div>
            <tk-icon @click.native="deleteMaterial(index)">delete</tk-icon>
          </div>
        </a-col>
      </a-row>
    </div>
    <!-- <a-divider v-if="formula.length" /> -->
    <a-row v-if="!isPC" type="flex" justify="center" :gutter="30">
      <a-col>
        <a-button size="large" style="font-size: 14px" @click="addParts">
          <tk-icon size="16" class="m-x-5 p-b-4">plus</tk-icon>增加半成品
        </a-button>
      </a-col>
      <a-col>
        <a-button size="large" style="font-size: 14px" @click="addMaterial">
          <tk-icon size="16" class="m-x-5 p-b-4">plus</tk-icon>增加原材料
        </a-button>
      </a-col>
    </a-row>
    <a-row v-else>
      <a-col :span="12">
        <a-button size="large" style="font-size: 14px" @click="addParts">
          <tk-icon size="16" class="m-x-5 p-b-4">plus</tk-icon>增加半成品
        </a-button>
      </a-col>
      <a-col :span="12">
        <a-button size="large" style="font-size: 14px" @click="addMaterial">
          <tk-icon size="16" class="m-x-5 p-b-4">plus</tk-icon>增加原材料
        </a-button>
      </a-col>
    </a-row>
    <template slot="footer">
      <div v-if="!isPC">
        <tk-flex between middle>
          <tk-flex middle gutter="12px">
            <div style="text-align: left">
              <div>材料：{{total}}</div>
              <div>杂费：{{incAccuracy}}</div>
              <div>利润：{{proAccuracy}}</div>
            </div>
            <a-divider type="vertical" style="height: 60px" />
            <div style="text-align: left">
              <div class="font-16 font-bold m-b-8">公布价：{{totalPrice}}</div>
              <a-input-number
                placeholder="请输入调整价"
                v-model="value"
                style="width: 130px"
                @blur="focus1()"
              ></a-input-number>
            </div>
          </tk-flex>
          <tk-flex>
            <a-button @click="cancel">取消</a-button>
            <a-button type="primary" @click="submit">确定</a-button>
          </tk-flex>
        </tk-flex>
      </div>
      <div v-else>
        <tk-flex class="m-b-10" wrap between>
          <div>材料：{{total}}</div>
          <div>杂费：{{incAccuracy}}</div>
          <div>利润：{{proAccuracy}}</div>
        </tk-flex>
        <tk-flex class="m-b-10" wrap between>
          <div class="font-16 font-bold m-b-8">公布价：{{totalPrice}}</div>
          <a-input-number
            placeholder="请输入调整价"
            v-model="value"
            style="width: 130px"
            @blur="focus1()"
          ></a-input-number>
        </tk-flex>
        <tk-flex right>
          <a-button @click="cancel">取消</a-button>
          <a-button type="primary" @click="submit">确定</a-button>
        </tk-flex>
      </div>
    </template>
  </a-modal>
</template>

<script>
import NP from 'number-precision'
export default {
  data () {
    return {
      isChanged: null,
      oriTotalPrice: '',
      show: false,
      value: null,
      adjustment: 0, // 调整价
      incidental: 0, // 杂费
      isPC: false,
      profit: 0, // 利润
      formula: [], // 配方
      parts: [], // 半成品
      materials: [], // 原材料
      data: {
        name: this.record.name,
        type: 'finishProduct',
        user: '',
        price: null,
        describe: '',
        reason: 'formulaChanged'
      },
      oriData: {
        adjustment: null,
        formula: [],
        partsId: [],
        rawMaterialId: []
      },
      materialCost: 0,
      finalPrice: 0
    }
  },

  computed: {
    userName () {
      return this.$store.state.user.name
    },
    // 杂费精度
    incAccuracy () {
      return NP.round(this.incidental, 2)
    },
    // 利润精度
    proAccuracy () {
      return NP.round(this.profit, 2)
    },
    // 总材料费
    total () {
      let total = 0
      this.formula.forEach((e) => {
        if (e.price) {
          total = NP.plus(total, e.price)
        }
      })
      return NP.round(total, 2)
    },
    // 总重量
    totalWeight () {
      let w = 0
      this.formula.forEach((f) => {
        if (f.weight) {
          w = NP.plus(w, f.weight)
        }
      })
      return w
    },
    // 公布价
    totalPrice () {
      let totalPrice = 0
      totalPrice = NP.plus(this.incAccuracy, this.proAccuracy, this.total, this.adjustment)
      return NP.round(totalPrice, 2)
    }
  },
  async created () {
    this.show = true
    this.getSurcharge()
    await this.getMaterial()
    await this.getParts()
    if (this.record.adjustment) {
      this.adjustment = this.record.adjustment
      this.value = this.record.adjustment
    }
    if (this.record.formula && this.record.formula.length) {
      // this.formula = this.record.formula
      this.formula = this.$tkHelper.deepClone(this.record.formula)
      this.formula.forEach((e) => {
        e.price = 0
        e.tonWeight = 0
        e.ratio = 0
        if (e.rawMaterial) {
          let s = this.materials.filter((f) => { return e.rawMaterial === f.objectId })
          e.selectMaterials = this.materials
          e.select = s[0]
        }
        if (e.parts) {
          let s = this.parts.filter((g) => { return e.parts === g.objectId })
          e.selectParts = this.parts
          e.select = s[0]
        }
      }, this)
    }
    await this.resetRecipe()
    this.oriTotalPrice = this.totalPrice
    this.show = false
    console.log('formula', this.formula)
  },
  mounted () {
    this.isMobile()
    this.getOriData()
    console.log(this.record)
  },
  methods: {
    getOriData () {
      this.oriData.adjustment = this.record.adjustment
      if (this.record.formula) { this.oriData.formula = this.record.formula }
      if (this.record.partsId) { this.oriData.partsId = this.record.partsId }
      if (this.record.rawMaterialId) { this.oriData.rawMaterialId = this.record.rawMaterialId }
    },
    isMobile () {
      // false PC
      this.isPC = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    cancel () {
      this.formula = []
      this.$emit('complete')
    },
    // 获取原材料
    async getMaterial () {
      let res = await this.$tkParse.getData('/classes/rawMaterial', {
        params: { limit: 10000 }
      }).catch(e => {
        this.$notification['error']({
          message: '网络错误，请重新尝试',
          description: '获取原材料失败'
        })
      })
      this.materials = res.results
    },
    // 获取半成品
    async getParts () {
      let par = await this.$tkParse.getData('/classes/parts', {
        params: { limit: 10000 }
      }).catch(e => {
        this.$notification['error']({
          message: '网络错误，请重新尝试',
          description: '获取半成品失败'
        })
      })
      this.parts = par.results
    },
    // 获取附加费
    async getSurcharge () {
      let sur = await this.$tkParse.getData('/classes/surcharge', {
        params: {
          where: {
            type: 'finish',
            proportion: this.record.proportion.objectId
          }
        }
      }).catch(e => { })
      if (sur.results.length) {
        this.incidental = sur.results[0].incidental
        this.profit = sur.results[0].profit
      }
    },
    // 添加半成品
    addParts () {
      this.formula.push({ parts: '', weight: null, price: 0, tonWeight: 0, ratio: 0, selectParts: this.parts, select: {} })
    },
    // 添加原材料
    addMaterial () {
      this.formula.push({ rawMaterial: '', weight: null, price: 0, tonWeight: 0, ratio: 0, selectMaterials: this.materials, select: {} })
    },
    // 删除配方
    async deleteMaterial (index) {
      this.formula.splice(index, 1)
      await this.$tkHelper.sleep(300)
      this.formula.forEach((x) => {
        let r = NP.divide(x.weight, this.totalWeight, 0.01)
        x.ratio = NP.round(r, 2)
        x.tonWeight = NP.times(x.ratio, 10)
        if (x.select.rate) {
          x.price = NP.times(x.select.price, x.select.rate, x.tonWeight, 0.001, 0.01)
        } else {
          x.price = NP.times(x.select.price, x.tonWeight, 0.001)
        }
      })
    },
    // 选择半成品
    selectParts (p, index) {
      this.formula[index].parts = p.objectId
      this.formula[index].select = p
      //  $set还是监测不到先重新赋值
      let a = this.formula
      this.formula = null
      this.formula = a
      // 判断此项是否有重量,有重量计算此项费用
      if (this.formula[index].weight) {
        this.resetRecipe()
      }
    },
    // 选择原材料
    selectMaterial (m, index) {
      this.formula[index].rawMaterial = m.objectId
      this.formula[index].select = m
      let a = this.formula
      this.formula = null
      this.formula = a
      // 判断此项是否有重量,有重量计算此项费用
      if (this.formula[index].weight) {
        this.resetRecipe()
      }
    },
    // 重量失去焦点
    async focus (weight, index) {
      console.log('focus')
      // 判断此项是否有原材料或半成品，已选择原材料或半成品计算此项费用
      if (weight && this.formula[index].select.price) {
        this.resetRecipe()
      }
      if (!weight) {
        this.formula[index].price = 0
        this.formula[index].tonWeight = 0
        this.formula[index].ratio = 0
        this.resetRecipe()
      }
    },
    // 重置配方
    resetRecipe () {
      this.formula.forEach((x) => {
        if (x.weight) {
          let r = NP.divide(x.weight, this.totalWeight, 0.01)
          x.ratio = NP.round(r, 2)
          x.tonWeight = NP.times(x.ratio, 10)
          if (x.rawMaterial) { x.price = NP.times(x.select.price, x.select.rate, x.tonWeight, 0.001, 0.01) }
          if (x.parts) { x.price = NP.times(x.select.price, x.tonWeight, 0.001) }
        }
      })
    },
    // 调整价失去焦点
    focus1 () {
      console.log('focus1')
      if (this.value) {
        this.adjustment = this.value
      } else {
        this.adjustment = 0
      }
    },
    async toPriceLog () {
      // 价格日志
      this.getSurcharge()
      this.resetRecipe()
      this.formula.forEach(el => {
        this.materialCost = NP.plus(this.materialCost, el.price)
      })
      this.materialCost = NP.round(this.materialCost, 2)
      this.finalPrice = NP.round(NP.plus(this.materialCost, this.adjustment, NP.round(this.incidental, 2), NP.round(this.profit, 2)), 2)
      this.data.user = this.userName
      // this.data.price = this.finalPrice
      this.data.describe = '由' + this.oriTotalPrice + '变为' + this.finalPrice
      if (this.oriTotalPrice !== this.finalPrice) {
        await this.$modelAjax.post('priceLog', this.data).catch(e => {
          throw this.$notification['error']({
            message: '修改失败',
            description: '修改失败，请重新尝试'
          })
        })
      }
    },
    // 保存
    async submit () {
      // 原材料id数组【便于筛选】
      let rawMaterialId = []
      // 半成品id数组【便于筛选】
      let partsId = []
      let f = []
      // 清除不完整原材料/半成品数据
      this.formula.forEach((e) => {
        if (e.rawMaterial && e.weight) {
          f.push({ rawMaterial: e.rawMaterial, weight: e.weight })
          rawMaterialId.push(e.rawMaterial)
        }
        if (e.parts && e.weight) {
          f.push({ parts: e.parts, weight: e.weight })
          partsId.push(e.parts)
        }
      })
      // 更改隐式原材料
      await this.$tkParse.post('/implicitMaterial/getImplicitMaterial', { objectId: this.record.objectId, partsId: partsId, rawMaterialId: rawMaterialId })
      await this.$modelAjax.put('finishProduct', this.record.objectId, {
        formula: f,
        partsId: partsId,
        rawMaterialId: rawMaterialId,
        adjustment: this.adjustment
      }).catch(e => {
        throw this.$notification['error']({
          message: '保存失败',
          description: '保存失败，请重新尝试'
        })
      })
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      // 若内容未空，无需判断改变
      if (this.oriData.formula.length === 0 && this.oriData.partsId.length === 0 && this.oriData.rawMaterialId === 0) {
        this.toPriceLog()
        await this.$tkHelper.sleep(300)
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      } else {
        // 判断改变
        let judgeAdjustment = null
        let judgeFormula = []
        let judgePartsId = []
        let judgeRawMaterialId = []
        // 判断调整值
        if (this.oriData.adjustment === this.adjustment) {
          judgeAdjustment = true
        } else {
          judgeAdjustment = false
          // return
        }
        // 判断成品
        if (this.oriData.partsId.sort().length === partsId.sort().length) {
          for (let a in partsId.sort()) {
            if (this.oriData.partsId.sort()[a] === partsId.sort()[a]) { judgePartsId.push(true) } else {
              judgePartsId.push(false)
              // return
            }
          }
        } else {
          judgePartsId.push(false)
          // return
        }
        // 判断原材料
        if (this.oriData.rawMaterialId.sort().length === rawMaterialId.sort().length) {
          for (let b in rawMaterialId.sort()) {
            if (this.oriData.rawMaterialId.sort()[b] === rawMaterialId.sort()[b]) { judgeRawMaterialId.push(true) } else {
              judgeRawMaterialId.push(false)
              // return
            }
          }
        } else {
          judgeRawMaterialId.push(false)
          // return
        }
        // 判断配方
        if (this.oriData.formula.sort().length === f.sort().length) {
          for (let i in f) {
            if (f[i].rawMaterial) {
              if (f.sort()[i].rawMaterial === this.oriData.formula.sort()[i].rawMaterial && f.sort()[i].price === this.oriData.formula.sort()[i].price) { judgeFormula.push(true) } else {
                judgeFormula.push(false)
                // return
              }
            }
            if (f[i].parts) {
              if (f.sort()[i].parts === this.oriData.formula.sort()[i].parts && f.sort()[i].price === this.oriData.formula.sort()[i].price) { judgeFormula.push(true) } else {
                judgeFormula.push(false)
                // return
              }
            }
          }
        } else {
          judgeFormula.push(false)
          // return
        }
        if (judgeAdjustment && judgeFormula.length && !judgeFormula.includes(false) && judgePartsId.length && !judgePartsId.includes(false) && judgeRawMaterialId.length && !judgeRawMaterialId.includes(false)) {
          this.vm.refresh()
          this.$emit('complete', 'cancel')
        } else {
          this.toPriceLog()
          await this.$tkHelper.sleep(300)
          this.vm.refresh()
          this.$emit('complete', 'cancel')
        }
      }
    }
  },
  props: {
    vm: null,
    record: Object
  }
}
</script>

<style scoped lang="scss">

.flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .ant-select{
    width: 85% !important;
  }
  .ant-input-number{
    width: 76%;
  }
}
.border{
  border-bottom: 1px solid #f00;
}
  ::v-deep .ant-select{
    width: 100% !important;
  }
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
  ::v-deep .ant-form-item-label > label {
    font-size: 14px !important;
    color: rgba(102, 102, 102, 1) !important;
  }
</style>
